import React from "react";
import { Button } from "react-bootstrap";

const AboutScreen = ({ passChildData }) => {
  return (
    <div className="mt-4">
      <h3>CS353 Database Systems 2022 Spring Course Project</h3>
      <h3>Application Name: Syncoder</h3>
      <h3>Project Topic: Online Coding Platform</h3>
      <h5 className="mt-4">Project Description</h5>
      <p>
        You will design a system where users prepare for technical job
        interviews. There are users, editors, and companies. Editors prepare
        both coding challenges, coding contests, and non-coding questions.
        Coding contests have several coding challenges. Users will try to solve
        challenges, answer questions and participate in contests. Companies also
        should be able to prepare a series of coding challenges and non-coding
        questions as a part of their interview process. Coding contests can be
        sponsored by companies. Both challenges and questions should have
        categories such as dynamic programming and system design, respectively.
      </p>
      <h4 className="mt-4">Project Team - Group 10</h4>
      <ul>
        <li>Arda Serim - 21802554 - Section 3</li>
        <li>Furkan Turunç - 21802197 - Section 3</li>
        <li>Muhammet Abdullah Koç - 21802832 - Section 3</li>
        <li>Murat Furkan Uğurlu - 21802062 - Section 3</li>
      </ul>
      <h4 className="mt-4">Reports</h4>
      <Button
        style={{ marginRight: "20px" }}
        onClick={() => passChildData("proposal")}
        className="mt-3"
      >
        Project Proposal Report
      </Button>
      <Button
        style={{ marginRight: "20px" }}
        onClick={() => passChildData("design")}
        className="mt-3"
      >
        Project Design Report
      </Button>
      <Button onClick={() => passChildData("final")} className="mt-3">
        Project Final Report
      </Button>
      <br></br>
    </div>
  );
};

export default AboutScreen;
